import { createAction } from '@reduxjs/toolkit';
import {
  ACT_SET,
  GLOBAL_ERRORS,
  ErrorGlobal,
  TYPE_ELEMENT,
} from '../../../common';

export const setGlobalErrors = createAction<ErrorGlobal[]>(
  `${GLOBAL_ERRORS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
